<template>
    <div class="assignment">
        <create-dialog v-model="dialog" :item="item" @fetch="fetchData"></create-dialog>
        <v-card>
            <v-card-title>
                Danh sách phân công
            <v-spacer></v-spacer>
            <excel-button @click="exportPrompt=true"/>
            <export-prompt url="assignments" v-model="exportPrompt"></export-prompt>
            <create-button @click="dialog=true"></create-button>
            <!-- <data-filter v-model="params" :filter="filter" @fetchData="fetchData">
            </data-filter> -->
            </v-card-title>
            
            <v-data-table
            :mobile-breakpoint="0"
            height="600px" fixed-header
            :headers="headers"
            :items="items"
            :page.sync="tableParams.page"
            :sort-by.sync="tableParams.sortBy"
            :sort-desc.sync="tableParams.sortDesc"
            :server-items-length="rowCount"
            :loading="isLoading"
            loading-text="Đang tải dữ liệu..."
            >
                <template v-slot:[`body.prepend`]="" >
                    <tr>
                        <td>
                            <v-text-field placeholder="Nhập" dense v-model="filters.code" outlined hide-details></v-text-field>
                        </td>
                        <td>
                            <v-text-field placeholder="Nhập" dense v-model="filters.employeeCode" outlined hide-details></v-text-field>
                        </td>
                        <td>
                            <v-text-field placeholder="Nhập" dense v-model="filters.employeeName" outlined hide-details></v-text-field>
                        </td>
                        <td>
                            <v-autocomplete placeholder="Nhập" dense v-model="filters.departmentCode"
                            item-text="name" item-value="code" :items="departments" :search-input.sync="departmentSearch" hide-no-data clearable
                            @update:search-input="fetchDepartment" outlined hide-details></v-autocomplete>
                        </td>
                        <td>
                            <v-autocomplete placeholder="Nhập" dense v-model="filters.shiftCode"
                            item-text="name" item-value="code" :items="shifts" hide-no-data clearable
                            outlined hide-details></v-autocomplete>
                        </td>
                        <td colspan="100%"></td>
                    </tr>
                </template>
                <template v-slot:[`item.actions`]="{item}">
                    <v-btn x-small @click="edit(item)" class="mx-1">
                        <v-icon small>mdi-pencil</v-icon> Sửa
                    </v-btn>
                    <!-- <v-btn x-small @click="remove(item)" class="mx-1" color="error">
                        <v-icon small>mdi-trash-can</v-icon> Xóa
                    </v-btn> -->
                </template>
                    <template v-slot:[`item.department`]="{item}" >
                        <v-chip class="ma-2 caption font-weight-bold" color="orange" label text-color="white" >
                            <v-icon left>
                                mdi-store
                            </v-icon>
                            {{item.department}}
                        </v-chip>
                    </template>
                <template v-slot:[`item.isCurrent`]="{item}" >
                    <v-icon v-if="item.isCurrent">mdi-check</v-icon>
                </template>
                <template
                    v-slot:[`item.time`]="{ item }"
                >
                    {{ formatTime(item.time) }}
                </template>
            </v-data-table>
        </v-card>
        <!-- ************** DELETE CONFIRMATION *************** -->
        <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
                <v-card-title class="headline">Bạn có chắc muốn xoá dữ liệu này?</v-card-title>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialogDelete=false">Thoát</v-btn>
                <v-btn color="blue darken-1" text @click="cfmDeleteItem">OK</v-btn>
                <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import http from '@/components/services/http-common';
import DataFilter from '@/components/DataFilter';
import CreateDialog from './Create.vue';
import * as moment from "moment/moment"

export default {
    name: "Attendance",
    components: {
        'data-filter': DataFilter,
        'create-dialog': CreateDialog,

    },
    props: ["breadcrumbs", "icon"],
    watch: {
        dialog(val) {
            if(!this.dialog)
                this.item=null;
        },
        tableParams: {
            handler (val) {
                this.fetchData();
            },
            deep: true,
        },
        filters: {
            handler (val) {
                this.tableParams.page=1;
                this.fetchData();
            },
            deep: true,
        },

    },
    computed: {
        params: function() {
            return {...this.tableParams, ...this.filters}
        }
    },
    data () {
        return {
            ROOT_URL: "assignments/",
            exportPrompt: false,
            //filter
            tableParams: {
                sortBy: [],
                sortDesc: [],
                page: 1,
            },
            filters:{
                code: null,
                employeeCode: null,
                employeeName: null,
                deparmentCode: null,
                shiftCode:null,
            },
            departmentSearch:null,
            departments: [],
            shifts:[],
            rowCount: 0,

            filter: {
                menu: false,
                search: "",
                searchAttr: "name",
                searchAttrs: undefined,
                FilterAttrs: [],
                FilterOn:["DepartmentTypeCode"],
                
                from: undefined,
                to: undefined,
                fromOns: [
                ],
                fromOn: "",
            },
            
            // VIEW DATA
            filterOpen: 1,

            //DATA TABLE
            totalItem: 0,
            items: [],
            search:"",
            options: {},
            isLoading: true,

            dialog: false, item: null,
            dialogDelete: false,
            targetItem: undefined,

            headers: [
                // { text: 'Thao tác', value: 'actions', width: 200},
                { text: 'Mã', align: 'start', value: 'code', width: '7rem'},
                { text: 'Mã nhân viên', align: 'start', value: 'employeeCode', width: '7rem'},
                { text: 'Nhân viên', align: 'start', value: 'employeeName', width: '9rem'},
                { text: 'Phòng', align: 'start', value: 'department', width: 200},
                { text: 'Vị trí', align: 'start', value: 'position', width: 250},
                { text: 'Ca làm việc', align: 'start', value: 'shift', width: 250},
                // { text: 'Hiện tại', value: 'isCurrent', width: '7rem'},
                { text: 'Tạo vào', value: 'createAt', width: 200 },
                { text: 'Sửa vào', value: 'updateAt'},
            ],
        }
    },
    methods: {
        formatTime(value) {
            return moment(value).format("DD/MM/YYYY HH:mm:ss");
        },
        fetchDepartment() {
            return http.get("departments/fetch", {
                params: {
                    search: this.departmentSearch
                }
            }).then(res => {
                this.departments = res.data;
            })
        },
        fetchShift() {
            return http.get("shifts").then(res => {
                this.shifts = res.data;
            })
        },
        fetchData () {
            return http.get(this.ROOT_URL, {
                params: this.params
            })
            .then(res => {
                this.isLoading = false;
                this.items = res.data.items;
                this.rowCount = res.data.totalItem;
            })
            .catch(err => {

            })
        },
        edit(item){
            this.item = item;
            this.dialog = true;
        },
        
        remove(item){
            this.dialogDelete = true;
            this.targetItem = item;
        },
        cfmDeleteItem() {
            // http.delete(this.ROOT_URL+this.targetItem.code).then(res => {
            //     this.fetchData();
            //     this.dialogDelete = false;
            // })
        },
    },
    created () {
        this.fetchData();
        this.fetchShift();
    },
    
}
</script>
<style scoped>

::v-deep table > tbody > tr:nth-child(1)>td {
    padding-right: 1px !important;
    padding-left: 1px !important;
}
</style>